import { CheckboxWrapper } from '../../../../checkbox/CheckboxWrapper';
import { Tooltip } from '../../../../tooltip/Tooltip';
import { Icon } from '../../../../icon/Icon';
import { ObjectsHeaderColumn } from '../../interfaces/object-header';

export interface ObjectHeaderCellProps {
  index: number;
  header: ObjectsHeaderColumn;
  selected?: number;
  total?: number;
  isViewMode?: boolean;
  isListIncluded?: boolean;
  isListIndeterminate: boolean;
  changeSelectAllCheckedState: (included: boolean) => void;
}

export function ObjectHeaderCell(props: ObjectHeaderCellProps) {
  const { index, header } = props;

  return index === 0 ? (
    <ObjectNameHeader {...props} />
  ) : (
    <span className='center-flex-row'>
      {header.displayName}{' '}
      {header.description && (
        <Tooltip dataId='' title={header.description}>
          <span className='ml-1 cursor-help center-flex-row'>
            <Icon name='help' size={1} />
          </span>
        </Tooltip>
      )}
    </span>
  );
}

function ObjectNameHeader({
  header,
  isViewMode,
  isListIncluded,
  isListIndeterminate,
  changeSelectAllCheckedState
}: Omit<ObjectHeaderCellProps, 'index'>) {
  if (isViewMode) {
    return (
      <span data-id='view-mode-header' className='text-secondary'>
        {header.displayName}
      </span>
    );
  }

  return (
    <CheckboxWrapper
      dataId='root'
      disabled={isViewMode}
      checkboxProps={{
        name: 'objectSelector',
        value: 'all-object-selector',
        className: '',
        disabled: isViewMode,
        checked: isListIncluded,
        indeterminate: isListIndeterminate,
        onChange: () => {
          changeSelectAllCheckedState(!isListIncluded);
        }
      }}
      label='Select All Objects'
    />
  );
}
